module.exports = __webpack_public_path__ + "static/media/universe-rhombi.c3a64687.svg";